const resourceTypes = Object.freeze({
  0: 'Alerts',
  1: 'Sms',
  2: 'Devices',
});

export default resourceTypes;
